module.exports = __webpack_public_path__ + "static/media/red.18d6f42e.png";